/*
 * ttg-preview-uploader.js — Nachträglicher Vorschaubild-Upload (nicht-blockierend).
 * ---------------------------------------------------------------------------
 * Ziel: Das Add-to-Cart darf NICHT auf den Vorschaubild-Upload warten (der bei
 * einem Railway-Cold-Start Sekunden dauern kann). Ablauf:
 *   1. Der Konfigurator (Engine) rendert beim Add den Snapshot sofort (schnell)
 *      und der Theme-Adapter legt ihn als dataURL + zugehörige _ttg_group in
 *      sessionStorage ('ttg:pendingPreview', seit 13.10.2026 eine Liste je Gruppe) ab — der Artikel geht OHNE Warten
 *      in den Warenkorb, danach navigiert das Theme zur /cart-Seite.
 *   2. Dieses global geladene Skript nimmt den Stash auf der /cart-Seite auf,
 *      lädt das Bild im Hintergrund zum previewUpload-Endpunkt hoch und trägt
 *      die zurückgegebene URL per /cart/change.js als _preview_image an die
 *      passende Hauptzeile (gleiche _ttg_group) nach.
 *   3. Danach morpht es die Cart-Section (dieselbe Maschinerie wie der
 *      Reconciler: /cart/change.js mit `sections` + eigenes `cart:update`),
 *      sodass der Thumbnail ohne Reload erscheint.
 *
 * Fehlertolerant & begrenzt wiederholend: Upload und Anhängen werden je bis zu
 * dreimal mit kurzer Wartezeit versucht (überbrückt Railway-Cold-Start und den
 * Race, dass die Cart-Zeile beim ersten Blick noch nicht sichtbar ist). Bleiben
 * sie erfolglos, wird der Artikel unverändert gelassen → der Produktbild-Fallback
 * im Cart-Template greift; der Kauf ist nie blockiert. Der Stash wird bei der
 * ersten Verarbeitung entfernt (die Wiederholungen laufen auf dem in-memory
 * gehaltenen Auftrag, kein Dauer-Retry über Seitenaufrufe hinweg), und ein
 * bereits gesetztes _preview_image wird nie überschrieben.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';
  if (window.__ttgPreviewUploader) return;   // Einmal-Init (theme.liquid lädt global)
  // Wahrheitswertig wie zuvor — die Sperre oben prüft nur auf truthy, das
  // Verhalten des Boot-Pfads ändert sich durch den Objektwechsel nicht. Neu ist
  // allein die Einstiegsfläche `nachtragen` (ganz unten), über die ein Aufrufer
  // OHNE Stash denselben Weg nutzen kann: der Cross-Sell auf /cart hat keine
  // Navigation, die ein sessionStorage-Stash überbrücken müsste — er hält den
  // Snapshot einfach in der Hand.
  window.__ttgPreviewUploader = {};

  var KEY = 'ttg:pendingPreview';
  var SELF = 'ttg-preview';                   // Marker für den eigenen cart:update-Dispatch
  var UPLOAD_TIMEOUT_MS = 60000;              // großzügig — Hintergrund, blockiert niemanden

  function route(name, fallback) { return (window.Theme && Theme.routes && Theme.routes[name]) || fallback; }

  // LISTE statt Einzelslot (13.10.2026, Anlass #1006054): zwei Konfigurator-Adds
  // innerhalb von 6 s — der zweite Stash überschrieb den ersten, die bestellte
  // erste Zeile blieb ohne Vorschau. Jetzt liegt unter KEY ein Array von
  // Aufträgen, je Warenkorb-Gruppe höchstens einer. Ein altes Einzelobjekt
  // (Stand vor dem Deploy, noch in einer offenen Sitzung) wird als Liste mit
  // einem Eintrag gelesen.
  function readAll() {
    try {
      var raw = sessionStorage.getItem(KEY); if (!raw) return [];
      var v = JSON.parse(raw);
      return Array.isArray(v) ? v.filter(function (x) { return x && x.group; }) : (v && v.group ? [v] : []);
    } catch (e) { return []; }
  }
  function writeAll(liste) {
    try {
      if (!liste.length) sessionStorage.removeItem(KEY);
      else sessionStorage.setItem(KEY, JSON.stringify(liste));
      return true;
    } catch (e) { return false; }
  }
  function ohne(liste, group) { return liste.filter(function (x) { return x.group !== group; }); }
  function clearPending(group) { writeAll(ohne(readAll(), group)); }
  function writePending(p) { var l = ohne(readAll(), p.group); l.push(p); return writeAll(l); }

  /**
   * Jeder ERWARTETE Ausstieg sagt, wo er aussteigt (24.08.2026).
   *
   * Vorher schwieg dieser Uploader an fuenf Stellen und meldete ausgerechnet nur
   * die eine unerwartete Ausnahme. Ein Ausfall, der sich in der Testsitzung nicht
   * zeigt, ist damit im Feld nicht zu fangen — man sieht nur, dass kein Bild da
   * ist, und weiss nicht, an welcher der fuenf Stellen es fehlt.
   *
   * Kein Abbruch, kein Einfluss auf den Kauf. Nur eine Zeile.
   * warn = etwas ist nicht durchgelaufen, info = Zwischenstand.
   */
  function melde(art, text, felder) {
    var zeile = '[ttg-preview] ' + text;
    if (felder) {
      var teile = [];
      for (var k in felder) if (felder[k] !== undefined && felder[k] !== null && felder[k] !== '') teile.push(k + '=' + felder[k]);
      if (teile.length) zeile += ' · ' + teile.join(' ');
    }
    try { (art === 'info' ? console.info : console.warn)(zeile); } catch (e) {}
  }

  /** Section-IDs aller Cart-Komponenten (Seite + Drawer) — für das Re-Rendering. */
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /** Eigenes cart:update feuern → cart-items-component morpht beide Oberflächen. */
  function dispatchUpdate(cart, sections) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: SELF,
      data: { source: SELF, sections: sections || {}, itemCount: cart ? cart.item_count : undefined },
    };
    document.dispatchEvent(ev);
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Wiederholungen für die zwei getrennt scheiternden Schritte (Upload, Anhängen).
  // Wartezeiten VOR Versuch 2 bzw. 3 — kurz, weil der Kunde auf /cart weiterklickt;
  // ein Cold-Start (~Sekunden) und ein noch nicht sichtbarer Cart-Eintrag (Race mit
  // dem AJAX-Add) sind so meist überbrückt. Alles Hintergrund, nichts blockiert.
  var UPLOAD_ATTEMPTS = 3, ATTACH_ATTEMPTS = 3;
  // Obergrenze der SEITENAUFRUFE, über die ein Auftrag weiterverfolgt wird.
  // Fünf, weil ein Auftrag nur auf einer Seite mit Warenkorb-Oberfläche zählt und
  // ein Kunde die in einer Sitzung realistisch drei- bis viermal sieht (Add,
  // Weiter-Einkaufen, zweites Add, Kasse). Fünf deckt das ab und begrenzt einen
  // dauerhaft scheiternden Auftrag trotzdem hart — ein Auftrag, der sich über eine
  // ganze Sitzung schleppt, ist kein Nachtrag mehr, sondern ein Defekt.
  var MAX_RUNDEN = 5;
  var BACKOFF_MS = [800, 2500];

  /** Einen Upload-Versuch: Bild-URL bei Erfolg, sonst null. ACHTUNG: Der Server
   *  legt die Zeile an, sobald der Body vollstaendig da ist — auch wenn dieser
   *  Client vorher abbricht (Railway 499). Bestellung #1005847 am 06.09.2026:
   *  drei identische Zeilen aus drei abgebrochenen Versuchen. Deshalb geht die
   *  Gruppen-ID als Query-Parameter mit (steht in der Request-Zeile, ist also
   *  auch ohne Antwort beim Server) — der Server kann das Bild spaeter der
   *  Bestellzeile zuordnen. */
  async function uploadOnce(p, blob, versuch) {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, UPLOAD_TIMEOUT_MS) : null;
    try {
      var uploadUrl = p.url + (p.group ? (p.url.indexOf('?') >= 0 ? '&' : '?') + 'group=' + encodeURIComponent(p.group) : '');
      var res = await fetch(uploadUrl, {
        method: 'POST', mode: 'cors', body: blob,
        headers: { 'Content-Type': blob.type || 'image/jpeg' },
        signal: ctrl ? ctrl.signal : undefined,
      });
      if (!res || !res.ok) {
        melde('warn', 'Upload abgewiesen', { status: res && res.status, versuch: versuch + '/' + UPLOAD_ATTEMPTS, group: p.group });
        return null;
      }
      var data = await res.json();
      return data && typeof data.url === 'string' ? data.url : null;
    } catch (e) {
      melde('warn', 'Upload-Fehler', { grund: e && (e.message || e.name), versuch: versuch + '/' + UPLOAD_ATTEMPTS, group: p.group });
      return null;
    }
    finally { if (timer) clearTimeout(timer); }
  }

  /** Einen Anhäng-Versuch. Rückgabe:
   *   'ok'           angehängt und Section aktualisiert
   *   'already'      schon ein Bild dran → fertig, NIE überschreiben
   *   'no-line'      Zeile (noch) nicht im Cart → erneut versuchen lohnt
   *   'change-failed' change.js abgelehnt → erneut versuchen */
  async function attachOnce(p, imgUrl) {
    var prop = p.property || '_preview_image';
    var cart = await fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
    // Zielzeile: ohne p.ziel wie bisher die Hauptzeile der Gruppe (keine Zuschlagszeile). Mit p.ziel
    // ({ role, kind }, 21.10.2026 Geschenkbeutel) genau die Zeile der Gruppe mit dieser _ttg_role/_ttg_kind —
    // so landet das Beutel-Vorschaubild an der Beutel-Zeile statt am Set. Alle bisherigen Aufrufer setzen kein ziel.
    var line = (cart.items || []).find(function (it) {
      if (!it.properties || it.properties._ttg_group !== p.group) return false;
      if (p.ziel) return it.properties._ttg_role === p.ziel.role && (!p.ziel.kind || it.properties._ttg_kind === p.ziel.kind);
      return it.properties._ttg_role !== 'surcharge';
    });
    if (!line) {
      var gefunden = [];
      (cart.items || []).forEach(function (it) { var g = it.properties && it.properties._ttg_group; if (g && gefunden.indexOf(g) === -1) gefunden.push(g); });
      melde('warn', 'Zeile nicht gefunden', { gesucht: p.group, gefundeneGruppen: gefunden.join(',') || '(keine)', zeilen: (cart.items || []).length });
      return 'no-line';
    }
    if (line.properties[prop]) return 'already';   // Doppel-Schutz: vorhandenes Bild bleibt

    // Bestehende Properties übernehmen + _preview_image ergänzen (change.js ERSETZT
    // die Properties der Zeile → vollständigen Satz mitschicken).
    var props = {};
    Object.keys(line.properties).forEach(function (k) { props[k] = line.properties[k]; });
    props[prop] = imgUrl;
    // Markierung „Vorschau fehlt" (Theme-Adapter, 23.09.2026) im selben Schritt
    // entfernen: Bild und Markierung stehen nie gleichzeitig an der Zeile.
    // Ihr Grund (_preview_grund, 03.10.2026) geht mit.
    delete props._preview_missing;
    delete props._preview_grund;

    var url = route('cart_change_url', '/cart/change');
    if (!/\.js$/.test(url)) url += '.js';
    // Menge AUSDRÜCKLICH mitschicken (07.10.2026, Kissen-Briefing 9): /cart/change.js
    // ohne quantity setzt die Zeile auf 1 zurück — gemessen im Wegwerf-Warenkorb,
    // 2 → 1. Jede Bestellung mit Menge > 1 verlor damit beim Bild-Nachtrag auf
    // /cart ihre Menge, auf allen Produkten mit previewUpload.
    var body = { id: line.key, quantity: line.quantity, properties: props };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }

    var updated = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.ok ? r.json() : null; });
    if (!updated) {
      melde('warn', 'cart/change.js abgewiesen', { group: p.group, zeile: line.key });
      return 'change-failed';
    }
    dispatchUpdate(updated, updated.sections || {});
    return 'ok';
  }

  /** Rückgabe 'ok' (Bild an der Zeile oder schon dran), sonst undefined.
   *  opts.zeileGeprueft: die Zeile stand eben noch im Warenkorb (boot hat geprüft) —
   *  fehlt sie beim Anhängen, hat der Kunde sie entfernt: kein Warten, Auftrag weg. */
  async function run(p, opts) {
    opts = opts || {};
    try {
      // Aus einer FRÜHEREN Runde schon hochgeladen? Dann nie wieder hochladen —
      // ein zweiter Upload legt eine zweite Zeile in Postgres an, und die ist ein
      // Fulfillment-Artefakt, kein Schönheitsfehler.
      var imgUrl = p.imgUrl || null;

      if (!imgUrl) {
        // dataURL → Blob
        var blob = await fetch(p.dataUrl).then(function (r) { return r.blob(); });
        if (p.maxUploadBytes && blob.size > p.maxUploadBytes) {
          // Zu groß bleibt zu groß — Wiederholen brächte nichts, der Auftrag geht weg.
          melde('warn', 'Bild zu gross, kein Upload', { bytes: blob.size, limit: p.maxUploadBytes, group: p.group });
          if (p.ausStash) clearPending(p.group);
          return;
        }

        // 1) Upload — mit Wiederholung. Sobald eine URL da ist, NICHT erneut hochladen.
        for (var i = 0; i < UPLOAD_ATTEMPTS && !imgUrl; i++) {
          if (i) await sleep(BACKOFF_MS[i - 1] || 2500);
          imgUrl = await uploadOnce(p, blob, i + 1);
        }
        // Upload dauerhaft gescheitert (z. B. Railway-Kaltstart): Auftrag LIEGEN
        // LASSEN, der nächste Warenkorb-Aufruf versucht es erneut. Vor dem
        // 24.08.2026 war er hier bereits gelöscht und der Fall damit verloren.
        if (!imgUrl) {
          melde('warn', 'Upload erfolglos, Auftrag bleibt liegen', { versuche: UPLOAD_ATTEMPTS, runde: p.runde, group: p.group });
          return;
        }

        // Upload geschafft → Auftrag SOFORT umschreiben: dataUrl raus, imgUrl rein.
        // Zwei Wirkungen: eine abgebrochene Runde lädt nie ein zweites Mal hoch,
        // und der Auftrag schrumpft von ~84 KB auf ein paar hundert Byte (das
        // sessionStorage-Limit liegt je nach Browser bei ~5 MB).
        if (p.ausStash) {
          p = { group: p.group, url: p.url, property: p.property, ziel: p.ziel,   // ziel mitnehmen (21.10.2026), sonst Hauptzeile
            maxUploadBytes: p.maxUploadBytes, runde: p.runde, ausStash: true, imgUrl: imgUrl };
          writePending(p);
        }
      }

      // 2) Anhängen — mit Wiederholung (Zeile evtl. noch nicht im Cart, change.js-Fehler).
      for (var j = 0; j < ATTACH_ATTEMPTS; j++) {
        if (j) await sleep(BACKOFF_MS[j - 1] || 2500);
        var r = await attachOnce(p, imgUrl);
        if (r === 'ok' || r === 'already') {         // fertig — erst JETZT weg
          if (p.ausStash) clearPending(p.group);
          return 'ok';
        }
        if (r === 'no-line' && opts.zeileGeprueft) {  // eben noch da, jetzt entfernt
          if (p.ausStash) clearPending(p.group);
          melde('warn', 'Zeile inzwischen entfernt, Auftrag verworfen', { group: p.group });
          return;
        }
      }
      // Alle Anhäng-Versuche erfolglos: Auftrag bleibt liegen (nur noch mit imgUrl),
      // der nächste Warenkorb-Aufruf hängt an, ohne erneut hochzuladen.
      melde('warn', 'Anhaengen erfolglos, Auftrag bleibt liegen', { versuche: ATTACH_ATTEMPTS, runde: p.runde, group: p.group });
    } catch (e) {
      melde('warn', 'Nachtrag abgebrochen', { grund: e && (e.message || e.name), runde: p && p.runde, group: p && p.group });
    }
  }

  function boot() {
    var liste = readAll().filter(function (p) { return p.url && (p.dataUrl || p.imgUrl); });
    if (!liste.length) return;
    // Auf eine Cart-Oberfläche warten: Aufträge behalten, bis eine da ist (Seite/Drawer).
    // Diese Zeile beantwortet zwei der drei Fragen, mit denen eine Fehlersuche sonst
    // im Dunkeln endet: lag der Auftrag hier, und warum lief er nicht.
    if (!document.querySelector('cart-items-component')) {
      melde('info', 'Auftrag liegt, keine Warenkorb-Oberflaeche — wartet', { auftraege: liste.length, groups: liste.map(function (p) { return p.group; }).join(',') });
      return;
    }
    // Nacheinander, nicht parallel: jeder Anhäng-Schritt morpht die Cart-Section;
    // zwei gleichzeitige change.js-Läufe würden sich die Darstellung gegenseitig
    // überschreiben (die Zeilen selbst bleiben getrennt).
    (async function () {
      // Reihenfolge nach dem Warenkorb (16.10.2026, Anlass #1006070): /cart.js GENAU
      // EINMAL lesen. Aufträge, deren Gruppe im Korb steht, zuerst; Aufträge ohne
      // Zeile verwerfen statt dreimal mit Wartezeit anzuhängen — bei #1006070 hielt
      // ein solcher Auftrag die bestellte Zeile ~4 s auf, der Kunde war schon in der
      // Kasse. Ist /cart.js nicht lesbar, bleibt alles wie vorher (alle, der Reihe nach).
      var t0 = Date.now();
      var imWarenkorb = await gruppenImWarenkorb();
      if (imWarenkorb) {
        var vorne = [];
        liste.forEach(function (p) {
          if (imWarenkorb[p.group]) { vorne.push(p); return; }
          clearPending(p.group);
          melde('warn', 'Auftrag ohne Warenkorbzeile verworfen', { group: p.group, gefundeneGruppen: Object.keys(imWarenkorb).join(',') || '(keine)' });
        });
        liste = vorne;
      }
      for (var i = 0; i < liste.length; i++) {
        var p = liste[i];
        // Rundenzähler VOR dem Lauf festschreiben. Genau darauf kommt es an: ein Lauf,
        // der mitten im Upload abgeschnitten wird (Kunde klickt weiter), kommt nie an
        // eine Stelle, an der er selbst hochzählen könnte — der Auftrag liefe sonst
        // über die ganze Sitzung weiter.
        p.runde = (p.runde || 0) + 1;
        p.ausStash = true;
        if (p.runde > MAX_RUNDEN) {
          clearPending(p.group);
          melde('warn', 'Nachtrag aufgegeben', { nachRunden: MAX_RUNDEN, group: p.group });
          continue;
        }
        writePending(p);
        melde('info', 'Auftrag aufgenommen', { group: p.group, runde: p.runde, hatBild: !!p.imgUrl, nr: (i + 1) + '/' + liste.length });
        // Der Auftrag bleibt liegen, bis er erledigt ist (run räumt auf) — vor dem
        // 24.08.2026 stand hier clearPending(), und ein abgeschnittener Lauf war
        // damit endgültig verloren, auch beim nächsten Seitenaufruf.
        var fertig = await run(p, { zeileGeprueft: !!imWarenkorb });
        if (fertig === 'ok') melde('info', 'Vorschau an Zeile', { group: p.group, msSeitBoot: Date.now() - t0 });
      }
    })();
  }

  /** Gruppen der Hauptzeilen im Warenkorb als { group: true }, oder null, wenn /cart.js nicht lesbar ist. */
  async function gruppenImWarenkorb() {
    try {
      var r = await fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      var cart = await r.json();
      var g = {};
      (cart.items || []).forEach(function (it) {
        var pr = it.properties || {};
        if (pr._ttg_group && pr._ttg_role !== 'surcharge') g[pr._ttg_group] = true;
      });
      return g;
    } catch (e) { return null; }
  }

  /**
   * Auftrag ablegen (13.10.2026) — der EINE Weg für alle Schreiber (Theme-Adapter,
   * Cross-Sell, Familie, Füße). Hängt an die Liste an; ein Auftrag derselben Gruppe
   * wird ersetzt. Rückgabe true, wenn er im sessionStorage steht.
   */
  window.__ttgPreviewUploader.stash = function (auftrag) {
    if (!auftrag || !auftrag.group) return false;
    try { return writePending(auftrag) && readAll().some(function (x) { return x.group === auftrag.group; }); }
    catch (e) { return false; }
  };

  /**
   * Nachtrag für Aufrufer OHNE Stash (Cross-Sell auf /cart, ui.mode 'cart').
   * Erwartet denselben Auftrag wie der Stash: { group, dataUrl, url, property,
   * maxUploadBytes }. Läuft durch dieselbe run()-Kette — Upload mit drei
   * Versuchen, Anhängen mit drei Versuchen, Section-Morph — und wirft nie.
   * Ein unvollständiger Auftrag wird still verworfen (wie ein leerer Stash).
   * Rückgabe: Promise, das auflöst, wenn der Nachtrag durch ist.
   *
   * Dieser Weg braucht den Stash gar nicht und kann deshalb parallel zu
   * liegenden Aufträgen laufen, ohne sie zu berühren.
   */
  window.__ttgPreviewUploader.nachtragen = function (auftrag) {
    if (!auftrag || !auftrag.dataUrl || !auftrag.group || !auftrag.url) return Promise.resolve();
    return run(auftrag);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
